export default "__VITE_ASSET__BabZmCYL__"